import { CompFormCore } from '../core/forms/form-wrapper/comp'

export const CompForm = CompFormCore
